import React, { useEffect, useRef } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { useLocation } from "react-router-dom";
import { BorderLeft, BorderRight } from "@mui/icons-material";
import { useReactToPrint } from "react-to-print";

const PendingSalesOrderPrint = React.forwardRef((props, ref) => {
    const pendingSalesOrderData = props.data || [];

    const login_details = sessionStorage.getItem("loginUser");
    const userD = JSON.parse(login_details);
    const userInfo = userD?.userInfo || {};

    const printRef = useRef();

    const handlePrint = () => {
        printFunction();
    };

    const printFunction = useReactToPrint({
        content: () => printRef.current,
        documentTitle: "Pending Sales Order",
        removeAfterPrint: true
    });

    const dateConversion = (date) => {
        if (!date) return "-";
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, "0")}/${String(
            d.getMonth() + 1
        ).padStart(2, "0")}/${d.getFullYear()}`;
    };

    const ITEMS_PER_PAGE = 10;
    const totalPages = Math.ceil(pendingSalesOrderData.length / ITEMS_PER_PAGE);

    const styles = {
        printTableHead: {
            fontSize: "10px",
           
            backgroundColor: "#e0f7fa",

            borderTop: "1px solid #b0bec5",
            borderBottom: "1px solid #b0bec5",
            borderLeft: "1px solid #b0bec5",
            borderRight: "1px solid #b0bec5",

            padding: "6px 4px",
            color: "#004d40",
            textTransform: "uppercase",
            letterSpacing: "0.5px",
        },
        printTableBody: {
            fontSize: "10px",
           
            // borderTop: "1px solid #b0bec5",
            // borderBottom: "1px solid #b0bec5",
            //  borderLeft: "1px solid #b0bec5",
            //  borderRight: "1px solid #b0bec5",

            padding: "6px 4px",
        },
        pageBreak: {
            pageBreakAfter: "always",
        },
        pageContainer: {
        
            margin: "60px 2px 30px 2px",
            padding: "15px",

            borderRadius: "4px",
            backgroundColor: "#ffffff",
        },

    };



    const TableHeaderRow = () => (
        <TableRow>
            <TableCell align="left" style={{ ...styles.printTableHead,  }} width="180">
                Customer Name
            </TableCell>
            <TableCell align="right" style={styles.printTableHead} width="80">
                PO NO
            </TableCell>
            <TableCell align="left  " style={styles.printTableHead} width="80">
                PO Date
            </TableCell>
            <TableCell align="right" style={styles.printTableHead} width="60">
                Prod ID
            </TableCell>
            <TableCell align="left" style={styles.printTableHead} width="80">
                Prod Code
            </TableCell>
            <TableCell align="left" style={styles.printTableHead} width="100">
                Cylinder Code
            </TableCell>
            <TableCell align="left" style={styles.printTableHead} width="60">
                Plan Qty
            </TableCell>
            <TableCell align="left" style={{ ...styles.printTableHead,  }} width="100">
                Prod Type
            </TableCell>
        </TableRow>
    );

    const PrintHeader = () => (
        <Box textAlign="center" sx={{ backgroundColor: "#c0c0c0", padding: "4px" }}>
            <Typography sx={{ fontSize: "18px", fontWeight: "bold" }}>PENDING SALES ORDER</Typography>
        </Box>
    );

    return (
        <Box ref={ref} style={{ margin: "30px", }}>
            {Array.from({ length: totalPages }).map((_, pageIndex) => {
                const startIdx = pageIndex * ITEMS_PER_PAGE;
                const endIdx = Math.min(startIdx + ITEMS_PER_PAGE, pendingSalesOrderData.length);
                const pageItems = pendingSalesOrderData.slice(startIdx, endIdx);

                return (
                    <Box key={pageIndex} style={pageIndex < totalPages - 1 ? styles.pageBreak : {}}>
                        <Paper sx={{ boxShadow: "none", ...styles.pageContainer }}>
                            <PrintHeader />

                            <TableContainer >
                                <Table size="small" style={{ ...styles.tableWrapper }}>
                                    <TableHead>
                                        <TableHeaderRow />
                                    </TableHead>
                                    <TableBody>
                                        {pageItems.map((row, index) => (
                                            <TableRow key={`${row.po_no}-${row.prod_id || index}`}>
                                                <TableCell align="left" style={{ ...styles.printTableBody,  }}>
                                                    {row.customer_name || "-"}
                                                </TableCell>
                                                <TableCell align="right" style={styles.printTableBody}>
                                                    {row.po_no || "-"}
                                                </TableCell>
                                                <TableCell align="left" style={styles.printTableBody}>
                                                    {dateConversion(row.po_date)}
                                                </TableCell>
                                                <TableCell align="right" style={styles.printTableBody}>
                                                    {row.prod_id || "-"}
                                                </TableCell>
                                                <TableCell align="left" style={styles.printTableBody}>
                                                    {row.prod_code || "-"}
                                                </TableCell>
                                                <TableCell align="left" style={styles.printTableBody}>
                                                    {row.cylinder_code || "-"}
                                                </TableCell>
                                                <TableCell align="left" style={styles.printTableBody}>
                                                    {row.plan_qty || "-"}
                                                </TableCell>
                                                <TableCell align="left" style={{ ...styles.printTableBody, }}>
                                                    {row.prod_type || "-"}
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                        {/* Fill empty rows */}
                                        {Array.from({ length: ITEMS_PER_PAGE - pageItems.length }).map((_, i) => (
                                            <TableRow key={`empty-${i}`}>
                                                {Array.from({ length: 8 }).map((__, j) => (
                                                    <TableCell
                                                        key={j}
                                                        align="center"
                                                        style={{
                                                            ...styles.printTableBody,
                                                            height: "28px",
                                                            border: "none"
                                                        }}
                                                    >
                                                        &nbsp;
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* Page Number */}
                            <Box textAlign="right" mt={2}>
                                <Typography variant="body2" sx={{ fontSize: "10px" }}>
                                    Page {pageIndex + 1} of {totalPages}
                                </Typography>
                            </Box>
                        </Paper>
                    </Box>
                );
            })}
        </Box>
    );
});

export default PendingSalesOrderPrint;

